module.exports = __webpack_public_path__ + "img/home-bg.c41286be.jpg";